<div class="popup-top-meta-data" id="tour-opportunity-score-details">
  <div class="score-container">
    <!-- Loading State -->
    @if (isLoadingScore) {
      <div class="loading-container">
        <div class="loader-spinner"></div>
        <p class="loading-text">Loading ...</p>
      </div>
    } @else if (scoreError) {
      <!-- Error State -->
      <div class="error-container">
        <div class="error-icon">⚠️</div>
        <p class="error-text">{{ scoreError }}</p>
      </div>
    } @else {
      <!-- Content -->
      <div id="tour-oppurtunity-indicator">
        <div class="score-header">
          <div class="score-header-left">
            <div class="header-content">
              <h3>Opportunity Indicator</h3>
              @if (pqmScores?.scored_with_custom_data !== undefined) {
                <span class="data-source-text">
                  @if (pqmScores?.scored_with_custom_data === true) {
                    Calculated based on custom manual entry data
                  } @else {
                    Calculated based on outreach form data
                  }
                </span>
              }
            </div>
          </div>
          <div class="score-value">
            @if (pqmScores) {
              <!-- Show score only if less than 40% of PQM inputs are missing -->
              @if (
                pqmScores.score.sc_pqm && pqmScores.score.missing_sc_pqm < 40
              ) {
                {{ pqmScores.score.sc_pqm | number: "1.2-2" }}
              } @else {
                NA
              }
            } @else {
              {{ getPropensityScore("Total Score") }}
            }
          </div>
        </div>

        <div class="score-details">
          <div
            class="score-range"
            [class]="
              this.pqmScores
                ? this.pqmScores.score.propensity_class
                : getScoreClass(getPropensityScore('Total Score'))
            "
          >
            <span class="range-label">{{
              getScoreRangeLabel(getPropensityScore("Total Score"))
            }}</span>
            <div class="range-bar">
              <div
                class="indicator"
                [style.left]="
                  getScorePercentage(getPropensityScore('Total Score')) + '%'
                "
              ></div>
            </div>
            <span class="range-description">Current Range</span>
          </div>

          <div class="score-info">
            <div class="info-item">
              <span class="label">Category</span>
              <span
                class="value"
                [class]="getScoreClass(getPropensityScore('Total Score'))"
              >
                @if (pqmScores) {
                  @if (pqmScores.score.propensity_class) {
                    {{ pqmScores.score.propensity_class.toUpperCase() }}
                  } @else {
                    {{ getPropensityClassFromScore(pqmScores.score.sc_pqm) }}
                  }
                  Propensity
                } @else {
                  {{ getScoreCategory(getPropensityScore("Total Score")) }}
                }
              </span>
            </div>
            <div class="info-item">
              <span class="label">Range</span>
              <span class="value">
                5-10: High Propensity<br />
                2-5: Medium Propensity<br />
                0-2 | LOW: Low Propensity
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="score-notes" id="tour-score-notes">
        <div class="sub-scores">
          <div class="sub-score-item">
            <div class="score-label-container">
              <span class="label">Business Background</span>
              @if (pqmScores && pqmScores.score.missing_sc_bb !== undefined) {
                <span class="missing-indicator"
                  >{{ pqmScores.score.missing_sc_bb | number: "1.2-2" }}% Inputs
                  Missing</span
                >
              }
            </div>
            <span
              class="value"
              [class]="
                getScoreClass(getPropensityScore('Business Background Score'))
              "
            >
              {{ getPropensityScore("Business Background Score") }}
            </span>
          </div>

          @if (pqmScores) {
            <div class="sub-score-item">
              <div class="score-label-container">
                <span class="label">Debt Service & Financial Leverage</span>
                @if (pqmScores.score.missing_sc_ds !== undefined) {
                  <span class="missing-indicator"
                    >{{ pqmScores.score.missing_sc_ds | number: "1.2-2" }}%
                    Inputs Missing</span
                  >
                }
              </div>
              <span
                class="value"
                [class]="getScoreClass(getPropensityScore('Debt Service'))"
              >
                {{ getPropensityScore("Debt Service") }}
              </span>
            </div>
          } @else {
            <div class="sub-score-item">
              <span class="label">Grant Funding</span>
              <span
                class="value"
                [class]="
                  getScoreClass(getPropensityScore('Grand Funding Score'))
                "
              >
                {{ getPropensityScore("Grand Funding Score") }}
              </span>
            </div>
          }

          @if (pqmScores) {
            <div class="sub-score-item">
              <div class="score-label-container">
                <span class="label">Requested Credit Facility</span>
                @if (pqmScores.score.missing_sc_fc !== undefined) {
                  <span class="missing-indicator">
                    {{ pqmScores.score.missing_sc_fc | number: "1.2-2" }}%
                    Inputs Missing
                  </span>
                }
              </div>
              <span
                class="value"
                [class]="
                  getScoreClass(getPropensityScore('Requested Credit Facility'))
                "
              >
                {{ getPropensityScore("Requested Credit Facility") }}
              </span>
            </div>
          } @else {
            <div class="sub-score-item">
              <span class="label">Damages Recovery</span>
              <span
                class="value"
                [class]="
                  getScoreClass(getPropensityScore('Damages Recovery Score'))
                "
              >
                {{ getPropensityScore("Damages Recovery Score") }}
              </span>
            </div>
          }
        </div>

        <!-- Composite Score Explanation -->
        @if (pqmScores) {
          <p class="note">
            The composite score is calculated using weighted components from
            Business Background, Debt Service & Financial Leverage, and
            Requested Credit Facility. Each component contributes proportionally
            to determine the final score.
          </p>
        } @else {
          <p class="note">
            The composite score is calculated using weighted components from
            Business Background, Grant Funding, and Damages Recovery
            assessments. Each component contributes proportionally to determine
            the final score.
          </p>
        }

        <!-- MRCE Section -->
        @if (pqmScores) {
          <div class="mrce-section">
            <div class="mrce-header">
              <h4>Maximum Recommended Total Credit Exposure</h4>
            </div>

            <div class="financial-metrics">
              <div class="metric-item cfads">
                <div class="metric-header">
                  <div class="metric-label-container">
                    <span class="metric-label">CFADS (Annual)</span>
                    <div class="custom-tooltip-wrapper">
                      <div class="info-icon-wrapper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          class="info-icon"
                        >
                          <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                          />
                        </svg>
                      </div>
                      <div class="custom-tooltip cfads-tooltip">
                        <div class="tooltip-header">
                          <h4>Annual Cash Flow Available for Debt Service</h4>
                        </div>
                        <div class="tooltip-content">
                          <p>
                            Primarily based on Business Financial Information
                            (SB form), adjusted by Personal Financial
                            Information and further adjusted by Applicant Score
                            (combined sub-scores of business background and debt
                            service & leverage).
                          </p>
                        </div>
                        <div class="tooltip-arrow"></div>
                      </div>
                    </div>
                  </div>
                  <span class="metric-value">
                    @if (pqmScores.score.cfads_anual) {
                      @if (pqmScores.score.cfads_anual < 0) {
                        -${{
                          pqmScores.score.cfads_anual * -1 | number: "1.2-2"
                        }}
                      } @else if (pqmScores.score.cfads_anual >= 0) {
                        ${{ pqmScores.score.cfads_anual | number: "1.2-2" }}
                      } @else {
                        NA
                      }
                    } @else {
                      NA
                    }
                  </span>
                </div>
                <div class="metric-description">
                  <strong>Annual Cash Flow Available for Debt Service:</strong>
                  Total (global) CFADS - i.e. includes Cash Flow available for
                  projected Debt Service related to requested credit facility as
                  well as Cash Flow to service any third party debt (existing
                  debt).
                </div>
              </div>

              <div class="metric-item wcap-need">
                <div class="metric-header">
                  <div class="metric-label-container">
                    <span class="metric-label">WCapNeed</span>
                    <div class="custom-tooltip-wrapper">
                      <div class="info-icon-wrapper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          class="info-icon"
                        >
                          <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                          />
                        </svg>
                      </div>
                      <div class="custom-tooltip wcap-tooltip">
                        <div class="tooltip-header">
                          <h4>Working Capital Need</h4>
                        </div>
                        <div class="tooltip-content">
                          <p>
                            Working capital need is primarily based on Assets &
                            Working Capital and is adjusted by Total Score
                            (combined sub-scores of Business Background, Debt
                            service & Leverage and Credit facility).
                          </p>
                        </div>
                        <div class="tooltip-arrow"></div>
                      </div>
                    </div>
                  </div>
                  <span class="metric-value">
                    @if (pqmScores.score.wCapNeed) {
                      @if (pqmScores.score.wCapNeed < 0) {
                        -${{ pqmScores.score.wCapNeed * -1 | number: "1.2-2" }}
                      } @else if (pqmScores.score.wCapNeed >= 0) {
                        ${{ pqmScores.score.wCapNeed | number: "1.2-2" }}
                      } @else {
                        NA
                      }
                    } @else {
                      NA
                    }
                  </span>
                </div>
                <div class="metric-description">
                  <strong>Working Capital Need:</strong>
                  The amount of short-term funding required to maintain
                  day-to-day operations, including inventory, accounts
                  receivable, and operational cash flow requirements.
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Business Overview Data Inputs -->
      @if (pqmScores) {
        <div
          class="business-overview-section"
          id="tour-business-overview-section"
        >
          <button
            id="tour-toggle-business-overview"
            type="button"
            class="business-overview-header"
            (click)="toggleBusinessOverview()"
            (keydown.enter)="toggleBusinessOverview()"
            (keydown.space)="toggleBusinessOverview()"
            [attr.aria-expanded]="isBusinessOverviewExpanded"
            aria-label="Toggle business overview data inputs"
          >
            <h4>Business Overview Data Inputs</h4>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="expand-icon"
              [class.expanded]="isBusinessOverviewExpanded"
            >
              <path
                d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
              />
            </svg>
          </button>

          @if (isBusinessOverviewExpanded) {
            <div class="business-overview-content">
              <div class="overview-section">
                <h5>Business Overview</h5>
                <div class="data-grid">
                  <div class="data-item">
                    <span class="label">Current FTEs</span>
                    <span class="value">{{
                      getPropertyValue("number_of_employees")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Business Age</span>
                    <span class="value">{{
                      getPropertyValue("business_established")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Business Description</span>
                    <span class="value">{{
                      getPropertyValue("business_description")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">NAICS</span>
                    <span class="value">{{
                      getPropertyValue("naics_code")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="overview-section">
                <h5>Financial Standing</h5>
                <div class="data-grid">
                  <div class="data-item">
                    <span class="label">Most Recent Tax Filing Period</span>
                    <span class="value"
                      >{{ getPropertyValue("reporting_period") }},
                      {{ getPropertyValue("period_months") }} Months</span
                    >
                  </div>
                  <div class="data-item">
                    <span class="label">Total Annual Revenue</span>
                    <span class="value">{{
                      getFormattedValue("total_revenue")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Total Profit</span>
                    <span class="value">{{
                      getFormattedValue("net_profit")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Total Assets</span>
                    <span class="value">{{
                      getFormattedValue("total_assets")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Net Worth</span>
                    <span class="value">{{
                      getFormattedValue("alternative_net_worth")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="overview-section">
                <h5>Existing debt</h5>
                <div class="data-grid">
                  <div class="data-item">
                    <span class="label"
                      >Outstanding Amount of Existing Business Loans</span
                    >
                    <span class="value">{{
                      getFormattedValue("existing_loans_amount")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label"
                      >Total Monthly Business Loan Payments</span
                    >
                    <span class="value">{{
                      getFormattedValue("monthly_debt_service")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="overview-section">
                <h5>Loan Request Information</h5>
                <div class="data-grid">
                  <div class="data-item">
                    <span class="label">Amount</span>
                    <span class="value">{{
                      getFormattedValue("loan_amount")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Term (months)</span>
                    <span class="value">{{
                      getPropertyValue("loan_term_months")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Project use</span>
                    <span class="value">{{
                      getPropertyValue("project_description")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label"
                      >Owners Investment/Contribution to Project</span
                    >
                    <span class="value">{{
                      getPropertyValue("contributing_personal_capital")
                    }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Available collateral</span>
                    <span class="value">{{
                      getPropertyValue("collateral_types")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
